import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiLock, FiEye } = FiIcons;

const badges = [
  { icon: FiShield, title: "Bank-Level Encryption", desc: "256-bit SSL on all data transfers." },
  { icon: FiLock, title: "No Hard Pull Initially", desc: "Check offers without hurting your credit score." },
  { icon: FiEye, title: "Full Transparency", desc: "See all fees and terms before you commit." },
];

export default function SecurityBadge() {
  return (
    <div className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {badges.map((b, i) => (
            <div key={i} className="flex items-start gap-4 p-6 bg-slate-50 rounded-2xl border border-slate-100">
              <div className="bg-green-100 p-3 rounded-xl shrink-0">
                <SafeIcon icon={b.icon} className="w-6 h-6 text-green-600" />
              </div>
              <div>
                <h4 className="font-bold text-slate-900 mb-1">{b.title}</h4>
                <p className="text-sm text-slate-500">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}